import parse from 'html-react-parser';

const SectionTitle = ({title, subtitle}) => {
    return (
        <div>
          <div className="subtitle wow fadeInUp" data-wow-delay=".2s">
            {subtitle && parse(subtitle)} <img src="/assets/images/icon/fireIcon.svg" alt="icon" />
          </div>
          <h2 className="title wow fadeInUp" data-wow-delay=".4s">{title && parse(title)}</h2>
        </div>
    );
};

export default SectionTitle;